import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/google.pdf";
import pdf2 from "../../Assets/../Assets/hackers.pdf"; // Step 2
import { FcGoogle } from "react-icons/fc";
import { FaHackerrank } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const resumeLink ="https://github.com/dipmandal353/Dip/blob/main/Certificate/google.pdf";

function CertificatesNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="certificates-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="success"
            href={""}
            target="_blank"
            style={{ maxWidth: "500px", maxHeight: "60px" }}
          >
            <FcGoogle />
            &nbsp;&nbsp;The Fundamentals Of Digital Marketing
          </Button>
        </Row>
        <Row className="certificates">
          <Document file={pdf} className="d-flex justify-content-center">
            <Page pageNumber={1} scale={width > 775 ? 1.3 : 0.5} />
          </Document>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <IoMdDownload />
            &nbsp;Download Certificate
          </Button>
        </Row>
        </Container>
        
       
        <Container fluid className="certificates-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="success"
            href={""}
            target="_blank"
            style={{ maxWidth: "500px", maxHeight: "60px" }}
          >
            <FaHackerrank />
            &nbsp;&nbsp;Hack-N-Slash
          </Button>
        </Row>
        <Row className="certificates">
          <Document file={pdf2} className="d-flex justify-content-center">
            <Page pageNumber={1} scale={width > 775 ? 1.3 : 0.5} />
          </Document>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf2}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <IoMdDownload />
            &nbsp;Download Certificate
          </Button>
        </Row>
        </Container>
    </div>
  );
}

export default CertificatesNew;
